import { useSummaryDialog } from './lib/useSummaryDialog';
import React from 'react';
import { X, Factory, BarChart3, Package, Trophy } from 'lucide-react';

export default function ProducaoTotal({ data, onClose, onOpenDashboard }) { 

  const { titleId, dialogRef, closeRef, onKeyDown } = useSummaryDialog(onClose);

  const formatCurrency = (value) => 
    Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  // Formatador para volume m³
  const formatVolume = (value) => 
    Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) + " m³";

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-2 sm:p-4">
      <div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby={titleId} onKeyDown={onKeyDown} className="flex max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] min-h-0 flex-col bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden">
        
        {/* Cabeçalho */}
        <div className="flex shrink-0 justify-between items-center gap-3 p-3 sm:p-4 border-b border-gray-800 bg-[#161b22]">
          <div className="flex min-w-0 items-center gap-2 text-cyan-400 font-bold tracking-wide sm:tracking-widest text-[10px] sm:text-xs uppercase">
            <Factory size={18} className="shrink-0" />
            <h2 id={titleId} className="min-w-0 break-words">Detalhamento de Produção</h2>
          </div>
          <button type="button" ref={closeRef} onClick={onClose} aria-label="Fechar Detalhamento de Produção" className="flex h-11 w-11 shrink-0 items-center justify-center rounded border border-gray-700 text-gray-200 hover:bg-gray-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-colors">
            <X size={20} />
          </button>
        </div>

        {/* Conteúdo em Grid */}
        <div className="min-h-0 overflow-y-auto overscroll-contain p-3 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
          
          {/* Card: Produção do Dia */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <p className="text-gray-500 text-[10px] uppercase font-bold mb-2 italic tracking-tighter">Produção do Dia</p>
            <p className="text-white text-xl sm:text-2xl break-words font-mono font-bold">
              {formatCurrency(data?.producaoDia)}
            </p>
          </div>

          {/* Card: Produção Acumulada (R$) */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800">
            <p className="text-gray-500 text-[10px] uppercase font-bold mb-2 italic tracking-tighter">Acumulado do Mês (Financeiro)</p>
            <p className="text-cyan-400 text-xl sm:text-2xl break-words font-mono font-bold">
              {formatCurrency(data?.producaoMes)}
            </p>
          </div>

          {/* NOVO: Card Produção Total m³ */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Produção Total do Dia m³</p>
              <Package size={14} className="text-gray-600" />
            </div>
            <p className="text-white text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
              {formatVolume(data?.producaoDiaM3 || 0)}
            </p>
          </div>
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Produção Total do Mês m³</p>
              <Package size={14} className="text-gray-600" />
            </div>
            <p className="text-white text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
              {formatVolume(data?.producaoTotalM3 || 0)}
            </p>
          </div>

          {/* NOVO: Card Maior Produção */}
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Produção do Mês</p>
              <Trophy size={14} className="text-amber-500 opacity-70" />
            </div>
            <p className="text-amber-500 text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
              {formatCurrency(data?.producaoMaior || 0)}
            </p>
          </div>
          <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Produção do Mês m³</p>
              <Trophy size={14} className="text-amber-500 opacity-70" />
            </div>
            <p className="text-amber-500 text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
              {formatCurrency(data?.maiorProducaoMes || 0)}
            </p>
          </div>

          <div className="md:col-span-2">
            <button type="button" onClick={onOpenDashboard} className="flex min-h-11 w-full items-center justify-center gap-2 rounded-lg border border-cyan-500/30 bg-cyan-600/10 px-3 py-3 text-cyan-300 transition-colors hover:bg-cyan-600/20 focus-visible:outline focus-visible:outline-cyan-400">
              <BarChart3 size={16} /><span className="text-[10px] font-black uppercase tracking-[0.2em]">Abrir painel Produção</span>
            </button>
          </div>

          {/* Footer de Insight 
          <div className="md:col-span-2 bg-[#161b22] p-4 rounded border border-cyan-900/30 flex items-center gap-4">
            <div className="bg-cyan-500/10 p-3 rounded-full text-cyan-400">
              <TrendingUp size={24} />
            </div>
            <div>
              <p className="text-gray-400 text-[10px] uppercase font-bold">Status da Planta</p>
              <p className="text-gray-300 text-xs italic">Dados integrados diretamente do ERP - Atualizado em tempo real.</p>
            </div>
          </div>*/}
        </div>

        {/* Botão Fechar */}
        <div className="shrink-0 p-3 sm:p-4 bg-[#0d1117] text-right border-t border-gray-800">
          <button 
            onClick={onClose}
            className="min-h-11 w-full sm:w-auto bg-gray-800 hover:bg-gray-700 text-white text-xs font-black py-3 px-8 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-all uppercase tracking-widest shadow-lg"
          >
            Fechar Janela
          </button>
        </div>
      </div>
    </div>
  );
}
